import { useMemo } from 'react';
import { PROJECT_STATUSES, STATUS_ICONS } from '@/utils/projectStatuses';
import type { ProjectStatus } from '@/utils/projectStatuses';
import { SelectDropdown } from '@/components/ui/SelectDropdown/SelectDropdown';
import './StatusSelect.css';

interface StatusSelectProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
  disabled?: boolean;
}

export function StatusSelect({
  label,
  value,
  onChange,
  fullWidth,
  disabled,
}: StatusSelectProps) {
  const displayValue = PROJECT_STATUSES.includes(value as (typeof PROJECT_STATUSES)[number]) ? value : PROJECT_STATUSES[0];

  const options = useMemo(
    () => [...PROJECT_STATUSES].reverse().map((s) => ({ value: s, label: s })),
    []
  );

  return (
    <div className="status-select">
      <SelectDropdown
        options={options}
        value={displayValue}
        onChange={onChange}
        label={label}
        fullWidth={fullWidth}
        disabled={disabled}
        renderValue={(selected) => {
          const Icon = STATUS_ICONS[(selected?.value ?? displayValue) as ProjectStatus] ?? STATUS_ICONS.Добавлен;
          return (
            <span className="status-select__value">
              <Icon sx={{ fontSize: 18 }} className="status-select__icon" />
              <span className="status-select__text">{selected?.label ?? displayValue}</span>
            </span>
          );
        }}
        renderOption={(opt) => {
          const Icon = STATUS_ICONS[opt.value as ProjectStatus];
          return (
            <>
              <Icon sx={{ fontSize: 18 }} className="status-select__option-icon" />
              <span className="status-select__option-text">{opt.label}</span>
            </>
          );
        }}
      />
    </div>
  );
}
